const PLATFORM_FONT_LINK_ID = 'platform-font-figtree';
const PLATFORM_FONT_URL =
  'https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap';

/**
 * Loads the platform design-system font (Figtree). The font is applied through the MUI theme
 * typography (see PLATFORM_FONT_FAMILY in feature-app-core portalConfiguration/theme/common.ts).
 */
export const loadPlatformFont = () => {
  if (typeof document === 'undefined' || document.getElementById(PLATFORM_FONT_LINK_ID)) {
    return;
  }
  const link = document.createElement('link');
  link.id = PLATFORM_FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = PLATFORM_FONT_URL;
  document.head.appendChild(link);
};
